import { Component, OnInit, OnDestroy, inject, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { Subscription, delay } from 'rxjs';
import { EventsService } from './shared/services/events/events.service';
import { UserSessionsService } from './shared/services/user-sessions/user-sessions.service';
import { IMessage } from './interfaces/message.interface';
import { IUserProfile } from './interfaces/user-profile.interface';
import { MainMenuComponent } from './shared/components/main-menu/main-menu.component';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from './shared/footer/footer.component';

import { RenewalPopupComponent } from './shared/components/renewal-popup/renewal-popup.component';
import { LoaderComponent } from './shared/components/loader/loader.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [MainMenuComponent, RouterOutlet, FooterComponent, RenewalPopupComponent, LoaderComponent],
})
export class AppComponent implements OnInit, OnDestroy {
  showLoader: boolean = false;
  message: IMessage | null = null;
  subs: Subscription[] = [];
  isShowRenewalPopup: boolean = false;
  userProfile: IUserProfile | null = null;
  exemptionRenewals: any;
  outageIntervalId: any;
  private eventsService: EventsService = inject(EventsService);
  private userSessionService: UserSessionsService = inject(UserSessionsService);

  ngOnInit() {
    this.userSessionService.setIdleCountdown();
    if (this.outageIntervalId) clearInterval(this.outageIntervalId);
    this.checkOutageTime();
    this.outageIntervalId = setInterval(() => {
      this.checkOutageTime();
    }, 60000);
    this.eventsService.showMessages$.subscribe({
      next: (message) => {
        this.message = message;
        if (message) {
          setTimeout(() => {
            this.closeMessage();
          }, 10000);
        }
      },
    });

    this.eventsService.showLoader$.pipe(delay(0)).subscribe({
      next: (status) => {
        this.showLoader = status;
      },
    });

    this.userSessionService.isShowRenewalPopup.subscribe({
      next: (userProfile) => {
        this.isShowRenewalPopup = false;
        if (userProfile) {
          this.isShowRenewalPopup = true;
          this.userProfile = userProfile;
        }
      },
    });
  }

  ngOnDestroy(): void {
    this.subs.forEach((sub) => sub.unsubscribe());
  }

  closeMessage() {
    this.message = null;
  }

  checkOutageTime() {
    this.userSessionService.outageMessage.next(null);
    const outageMessage =
      ' The UPMC Vaccine Portal is currently undergoing maintenance.  During this time, vaccine documentation, exemption requests, and declinations for COVID and Flu cannot be submitted.  Please try again later. ';

    if (this.isOutageNow()) {
      this.userSessionService.outageMessage.next(outageMessage);
    }
  }

  isOutageNow() {
    // outrage message is shown only on March 24th 2022 8PM to 12AM
    const date = new Date();
    const utcYearNow = date.getUTCFullYear();
    const utcMonthNow = date.getUTCMonth();
    const utcDateNow = date.getUTCDate();
    const utcHoursNow = date.getUTCHours();
    let isOutageNow = false;

    const isOutageDayNow = utcYearNow === 2022 && utcMonthNow === 2 && utcDateNow === 25;
    if (isOutageDayNow) {
      isOutageNow = utcHoursNow >= 0 && utcHoursNow < 4;
    } else {
      isOutageNow = false;
    }
    return isOutageNow;
  }
}
